function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import { ServiceAdvancedSettings } from "./ServiceAdvancedSettings";
export function useServiceAdvancedSettingsAdditionalSection(props) {
  const [serviceAdvancedSettingsRef, setServiceAdvancedSettingsRef] = useState(null);
  return {
    disableBorder: !(serviceAdvancedSettingsRef !== null && serviceAdvancedSettingsRef !== void 0 && serviceAdvancedSettingsRef.showAdvancedSettings),
    value: /*#__PURE__*/React.createElement(ServiceAdvancedSettings, _extends({
      key: "adv",
      ref: setServiceAdvancedSettingsRef
    }, props))
  };
}